import { render, staticRenderFns } from "./FastOrdersTableMobile.vue?vue&type=template&id=f644d70c&scoped=true"
import script from "./FastOrdersTableMobile.vue?vue&type=script&lang=js"
export * from "./FastOrdersTableMobile.vue?vue&type=script&lang=js"
import style0 from "./FastOrdersTableMobile.vue?vue&type=style&index=0&id=f644d70c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f644d70c",
  null
  
)

export default component.exports